import { render, staticRenderFns } from "./EditSector.vue?vue&type=template&id=a9b88d18&scoped=true&"
import script from "./EditSector.vue?vue&type=script&lang=js&"
export * from "./EditSector.vue?vue&type=script&lang=js&"
import style0 from "./EditSector.vue?vue&type=style&index=0&id=a9b88d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b88d18",
  null
  
)

export default component.exports